import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";
import "./CvComponent.css";
import cvData from "../../shared/cv_data.json";

class CvComponent extends Component {
  handlePrint = () => {
    window.print();
  };

  render() {
    const theme = this.props.theme;

    return (
      <div className="cv-page-container">
        <Header theme={theme} />

        <Fade bottom duration={1000} distance="30px">
          <div className="cv-actions-bar">
            <button className="cv-btn cv-print-btn" onClick={this.handlePrint}>
              🖨️ Print / Save as PDF
            </button>
            <a
              className="cv-btn cv-html-btn"
              href={`${process.env.PUBLIC_URL || ""}/cv.html`}
              target="_blank"
              rel="noopener noreferrer"
            >
              📄 Standalone CV
            </a>
          </div>

          <div className="cv-card-wrapper">
            <div className="cv-card">
              {/* Main Content Area (Left) */}
              <main className="cv-card-main">
                <header className="cv-card-header">
                  <h1 className="cv-name">{cvData.name}</h1>
                  <p className="cv-title">{cvData.title}</p>
                </header>

                <section className="cv-section">
                  <h2 className="cv-section-title">Professional Summary</h2>
                  <p className="cv-summary-text">{cvData.professionalSummary}</p>
                </section>

                <section className="cv-section">
                  <h2 className="cv-section-title">Employment History</h2>
                  {cvData.employmentHistory.map((item, index) => (
                    <div key={index} className="cv-history-item">
                      <h3 className="cv-item-title">
                        {item.role}, {item.company}, {item.location}
                      </h3>
                      <div className="cv-item-duration">{item.duration}</div>
                      <div className="cv-item-descriptions">
                        {item.descriptions.map((desc, i) => (
                          <p key={i}>{desc}</p>
                        ))}
                      </div>
                    </div>
                  ))}
                </section>

                <section className="cv-section">
                  <h2 className="cv-section-title">Education</h2>
                  {cvData.education.map((item, index) => (
                    <div key={index} className="cv-history-item">
                      <h3 className="cv-item-title">
                        {item.degree}, {item.institution}, {item.location}
                      </h3>
                      <div className="cv-item-duration">{item.duration}</div>
                      <div className="cv-item-descriptions">
                        {item.descriptions.map((desc, i) => (
                          <p key={i}>{desc}</p>
                        ))}
                      </div>
                    </div>
                  ))}
                </section>
              </main>

              {/* Sidebar Area (Right) */}
              <aside className="cv-card-sidebar">
                <section className="cv-sidebar-section">
                  <h2 className="cv-sidebar-title">Details</h2>
                  <div className="cv-detail-row">{cvData.details.city}</div>
                  <div className="cv-detail-row">{cvData.details.country}</div>
                  <div className="cv-detail-row">
                    <a href={`tel:${cvData.details.phone}`}>
                      {cvData.details.phone}
                    </a>
                  </div>
                  <div className="cv-detail-row">
                    <a href={`mailto:${cvData.details.email}`}>
                      {cvData.details.email}
                    </a>
                  </div>
                </section>

                <section className="cv-sidebar-section">
                  <h2 className="cv-sidebar-title">Links</h2>
                  {cvData.links.map((link, index) => (
                    <div key={index} className="cv-link-row">
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {link.url}
                      </a>
                    </div>
                  ))}
                </section>

                <section className="cv-sidebar-section">
                  <h2 className="cv-sidebar-title">Skills</h2>
                  {cvData.skills.map((skill, index) => (
                    <div key={index} className="cv-skill-row">
                      <div className="cv-skill-name">{skill.name}</div>
                      <div className="cv-skill-track">
                        <div
                          className="cv-skill-bar"
                          style={{ width: `${skill.level}%` }}
                        />
                      </div>
                    </div>
                  ))}
                </section>

                <section className="cv-sidebar-section">
                  <h2 className="cv-sidebar-title">Languages</h2>
                  {cvData.languages.map((lang, index) => (
                    <div key={index} className="cv-skill-row">
                      <div className="cv-skill-name">{lang.name}</div>
                      <div className="cv-skill-track">
                        <div
                          className="cv-skill-bar"
                          style={{ width: `${lang.level}%` }}
                        />
                      </div>
                    </div>
                  ))}
                </section>
              </aside>
            </div>
          </div>
        </Fade>

        <Footer theme={theme} />
        <TopButton theme={theme} />
      </div>
    );
  }
}

export default CvComponent;
